import { CountryOption } from '@api/getCountries'

export function sortCountries(
  countries: CountryOption[],
  popularCountryCodes: string[]
) {
  const otherCountries = countries.filter(
    ({ value }) => !popularCountryCodes.includes(value)
  )

  const popularCountries = popularCountryCodes
    .map(
      (popularCountryCode) =>
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        countries.find((country) => country.value === popularCountryCode)!
    )
    .filter((country) => country !== undefined)

  return [...popularCountries, ...otherCountries]
}

export const countriesWithSubdivisions = ['US', 'CA', 'MX']
export const countriesWithZipCodes = ['US', 'CA', 'MX']
export const popularCountries = ['US', 'CA', 'MX']
